export default class SimpleTimeline {
    constructor(context = document) {
        this.steps = [];
        this.context = context;
    }

    add(item, delay) {
        this.steps.push({ item, delay });
        return this;
    }

    run() {
        this.steps.reduce((p, step) => p.then(() => new Promise((resolve) => {
            setTimeout(() => {
                switch (true) {
                case step.item instanceof Array:
                    step.item.forEach((element) => element.classList.add('animated'));
                    break;
                case step.item instanceof Node:
                    step.item.classList.add('animated');
                    break;
                case step.item instanceof Function:
                    step.item();
                    break;
                case typeof step.item === 'string':
                    this.context.querySelector(step.item).classList.add('animated');
                    break;
                default:
                    break;
                }
                resolve();
            }, step.delay);
        })), Promise.resolve());
    }
}
